import { useStores } from "mobx-stores/_root-store";
import { useMemo } from "react";

export const useCheckPermission = (accessPermission?: "all" | string[]) => {
  const {
    authentication: { grantedPermissions },
  } = useStores();
  const hasPermission = useMemo(() => {
    if (!accessPermission || accessPermission === "all") {
      return {
        allowAccess: true,
        accessKey: "all",
      };
    }
    let accessKey: string | null = null;
    let allowAccess = false;
    accessPermission.forEach((accessPer, idx) => {
      if (grantedPermissions.includes(accessPer)) {
        if (!accessKey) {
          accessKey = accessPer;
        }
        allowAccess = true;
        return;
      }
    });
    return {
      allowAccess,
      accessKey,
    };
  }, [accessPermission, grantedPermissions]);
  return hasPermission;
};
